module.exports = __webpack_public_path__ + "img/service_type_form.ca72599d.png";